module.exports = __webpack_public_path__ + "static/complicated1-01b033c7a7189be01a001c0c21fb76a8.gif";